export default __webpack_public_path__ + "static/media/RhymesWeather_07.f7d23ab6.png";